import { render, staticRenderFns } from "./bus-seat-outlined.vue?vue&type=template&id=425cdbbd"
import script from "./bus-seat-outlined.vue?vue&type=script&lang=js"
export * from "./bus-seat-outlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports